// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__39Gqj","footer":"Form_footer__3RIDi"};